import React from "react";
import DropdownCover from "../dropdownCover";

export interface ICoverSelectProps {
  features?: any[] | null;
  productId?: string;
  typeCover?: string;
  handleOnChangeCover?: Function | null;
  checkDesk?: boolean;
  minKdeProId?: number;
  isNeedDropdown?: boolean;
  labelDefault?: string;
}

const CoverSelect = (props: ICoverSelectProps) => {
  const {
    features,
    productId,
    typeCover,
    handleOnChangeCover,
    checkDesk,
    minKdeProId,
    isNeedDropdown = true,
    labelDefault,
  } = props;

  return (
    <>
      {!isNeedDropdown ? (
        labelDefault && (
          <p className="product-item__property-label">{labelDefault}</p>
        )
      ) : (
        <DropdownCover
          features={features}
          productId={productId}
          typeCover={typeCover}
          handleOnChangeCover={handleOnChangeCover}
          checkDesk={checkDesk}
          minKdeProId={minKdeProId}
        />
      )}
    </>
  );
};

export default CoverSelect;
